exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiSelectHeader__closeButton___39Lyp {\n  float: right;\n  font-size: 20px;\n  color: #828282;\n  margin-top: 6px; }\n\n.multiSelectHeader__header___3a7Lk {\n  padding-bottom: 17px;\n  box-shadow: 0 1px 0 0 #dbdbdb;\n  margin-bottom: 15px; }\n\n.multiSelectHeader__title___wQHqX {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #292929; }\n", ""]);

// exports
exports.locals = {
	"closeButton": "multiSelectHeader__closeButton___39Lyp",
	"header": "multiSelectHeader__header___3a7Lk",
	"title": "multiSelectHeader__title___wQHqX"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/MultiSelectModal/styles/multiSelectHeader.scss
// module id = 2129
// module chunks = 6